module.exports = __webpack_public_path__ + "static/img/pdf.240241f9.svg";